export default {
  hayApiDataCargada: (state) => (key) => {
    return state.apiData[key].length > 0
  },
  hayProyectosCargados: (state) => () => {
    return state.apiData.proyectos.length > 0
  },
  getProyectoPorCodigo: (state) => (codigo) => {
    for (let i = 0; i < state.apiData.proyectos.length; i++) {
      if (state.apiData.proyectos[i].codigo_proyecto === codigo) {
        return state.apiData.proyectos[i]
      }
    }
    return null
  },
  getProyectosUsuario: (state) => (queryString) => {
    let result = state.user.proyectos ? state.user.proyectos : []
    if (!queryString) {
      return result
    } else {
      let aResult = []
      for (let i = 0; i < result.length; i++) {
        aResult.push('_id=' + result[i])
      }
      return aResult.join('&')
    }
  },
  getNombreRolPorCodigo: (state) => (codigo) => {
    if (state.apiData.roles && state.apiData.roles[codigo]) {
      return state.apiData.roles[codigo].name
    }
    return codigo
  },
  getTipoRolPorCodigo: (state) => (codigo) => {
    if (state.apiData.roles && state.apiData.roles[codigo]) {
      return state.apiData.roles[codigo].type
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js